import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const inputClass =
  "w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-[#2563EB] focus:ring-2 focus:ring-blue-100";

// Champ mot de passe avec œil d'affichage/masquage à droite.
// IMPORTANT : composant au niveau module (jamais défini dans un autre composant),
// sinon React le démonte à chaque frappe (perte de focus et de caractères).
export const PasswordInput = ({ value, onChange, placeholder, testId, toggleTestId, autoComplete }) => {
  const { t } = useLanguage();
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        data-testid={testId}
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required
        minLength={6}
        autoComplete={autoComplete}
        className={`${inputClass} pr-12`}
      />
      <button
        type="button"
        data-testid={toggleTestId}
        onClick={() => setShow((s) => !s)}
        tabIndex={-1}
        aria-label={show ? t("Masquer le mot de passe") : t("Afficher le mot de passe")}
        className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full p-1 text-slate-400 transition hover:text-slate-600"
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
};
